// import { useContext } from 'react';
// import { ChatContext } from './ChatsSocketProvider';
import '../../Pages/Chats.css';

const TypingIndicator = () => {
  // const { isTyping, chatMode } = useContext(ChatContext);
  // if (!isTyping) {
  //   return null;
  // }

  return (
      <div className='typing-container'>
          <div className='typing-badge'>Thinking...</div>
          <div className="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
          </div>
          {/*<div className='typing-badge'>{chatMode === 'bot' ? 'Thinking...' : 'Typing...'}</div>*/}
      </div>
  );
};

export default TypingIndicator;
